import { Component, Prop, Vue } from 'vue-property-decorator'
import Call from '@/components/shared/call/Call.vue'

@Component({
  components: { Call }
})
export default class ShowCall extends Vue {
}
